import * as Yup from 'yup'

import { FC, createContext, useContext, useState } from "react";

import { ErrorMessage } from '../../../../widgets';
import { FormDataContext } from './FormDataContext';
import { Formik } from 'formik';
import { IEntity } from '../../../../base/types';
import { IFormPros } from './IFormProps';
import React from 'react';
import { useDataContext } from '../../../page/context';
import { useNavigate, useParams } from 'react-router-dom';
import { PageLinkHelper } from '../../../../base/helpers';

interface IFormContext {
    updateSchema: (addedSchema: Yup.ObjectSchema<IEntity>) => void
}

const defaultSchema = Yup.object().shape({})

const context = createContext<IFormContext>({
    updateSchema: () => { }
})

export const useFormContext = () => {
    return useContext(context)
}

export interface IFormContextProps extends IFormPros {
    className?: string
    children?: React.ReactNode
}

export const FormContext: FC<IFormContextProps> = React.memo(({
    systemId, autoSave, pageLink, title, className, children
}) => {
    const { result: data, saveData } = useDataContext()
    const [formState, setFormState] = useState<{ schema: Yup.ObjectSchema<IEntity>, values: IEntity }>({ schema: defaultSchema, values: {} });
    const { siteId } = useParams()
    const navigate = useNavigate()

    const updateSchema = (fieldSchema: Yup.ObjectSchema<IEntity>) => {
        const { schema } = formState;
        const newFields = Object.keys(fieldSchema.fields);
        const field = newFields[0];
        if (newFields.length === 0 || Object.keys(schema.fields).includes(field)) {
            return;
        }

        setFormState(state => {
            const { schema, values } = state
            const newSchema = schema.concat(fieldSchema)
            const record = data as IEntity
            const newValues = record ? { ...values, [field]: record[field] || '' } : values

            return { schema: newSchema, values: newValues };
        });
    }

    const updateInitValues = (data: IEntity) => {
        const { schema, values } = formState

        const record = data as IEntity
        const fields = Object.keys(schema.fields)
        fields.forEach(field => values[field] = record[field] || '')
        setFormState({ schema, values });

        if (pageLink && siteId) {
            navigate(PageLinkHelper.getPageLinkUrl(siteId, pageLink))
        }
    }

    return <>
        <context.Provider value={{ updateSchema }}>
            <Formik
                validationSchema={formState.schema}
                initialValues={formState.values}
                enableReinitialize={true}
                onSubmit={(values, { setSubmitting, setStatus }) => {
                    if (values === undefined || values === null || Object.keys(values).length === 0) {
                        setStatus('No data to save')
                        return
                    }

                    setSubmitting(true)
                    saveData({ values, systemId })
                        .then((data) => {
                            return updateInitValues(data)
                        })
                        .catch(error => {
                            console.error(error)
                        })
                        .finally(() => setSubmitting(false))
                }}>
                {({ values, isSubmitting, status: formStatus, setSubmitting, setStatus }) => {
                    return <>
                        <FormDataContext
                            systemId={systemId}
                            autoSave={autoSave}
                            pageLink={pageLink}
                            title={title}
                            className={className}
                            values={values}
                            initValues={formState.values}
                            isSubmitting={isSubmitting}
                            updateInitValues={updateInitValues}
                            setSubmitting={setSubmitting}
                            setStatus={setStatus}
                        >
                            {children}
                        </FormDataContext>
                        <ErrorMessage show={!!formStatus} message={formStatus} className="mt-5" />
                    </>
                }}
            </Formik>
        </context.Provider>
    </>
})



